import React, { FC, ReactElement } from 'react'
import styles from './ContainedInput.module.css'
import classNames from 'classnames'

import Input, { InputProps } from '@/components/input'

const ContainedInput: FC<InputProps> = (props): ReactElement => {
	return (
		<Input
			{...props}
			className={classNames(styles.root, props.className)}
			inputClassName={classNames(props.inputClassName, styles.input, {
				[styles.error]: !!props?.error
			})}
		/>
	)
}

export default ContainedInput
